import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 flex flex-col" data-id="element-420">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-4 sticky top-0 bg-white/90 backdrop-blur-sm z-10" data-id="element-421">
        <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-422">
          <a href="#" className="flex items-center gap-2 text-sm text-gray-500 hover:text-rose-600 transition-colors" data-id="element-423">
            <ArrowLeft className="h-4 w-4" data-id="element-424" />
            Volver al inicio
          </a>
          <span className="font-bold text-gray-900" data-id="element-425">
            Di Esto, <span className="text-rose-600" data-id="element-426">No Aquello™</span>
          </span>
        </div>
      </header>

      <main className="flex-grow px-4 py-12" data-id="element-427">
        <div className="max-w-3xl mx-auto prose prose-rose prose-headings:font-bold prose-a:text-rose-600" data-id="element-428">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-429">
            Términos y Condiciones
          </h1>
          <p className="text-sm text-gray-500 mb-8" data-id="element-430">
            Última actualización: Febrero 2026
          </p>

          <h3 data-id="element-431">1. Introducción</h3>
          <p data-id="element-432">
            Bienvenido a <strong data-id="element-433">Di Esto, No Aquello™</strong>. Estos términos
            y condiciones rigen el uso de nuestro sitio web y la compra de
            nuestros productos digitales. Al acceder a este sitio y realizar una
            compra, aceptas estos términos en su totalidad.
          </p>
          <p data-id="element-434">
            Este sitio y sus productos son operados por{' '}
            <strong data-id="element-435">Amor Con Principios</strong>, con base en Estados Unidos
            (USA).
          </p>

          <h3 data-id="element-436">2. Productos Digitales</h3>
          <p data-id="element-437">
            Vendemos productos digitales (ebooks y guías en formato PDF). Al
            comprar, recibes una licencia personal, no exclusiva e
            intransferible para descargar y acceder al contenido. Queda
            prohibida la reventa, distribución o copia no autorizada de nuestros
            materiales.
          </p>

          <h3 data-id="element-438">3. Pagos y Procesamiento</h3>
          <p data-id="element-439">
            Todos los pagos son procesados de forma segura a través de la
            plataforma <strong data-id="element-440">Hotmart</strong>. Nosotros no almacenamos ni
            tenemos acceso a tus datos completos de tarjeta de crédito o débito.
            Al realizar una compra, también aceptas los términos y condiciones
            de Hotmart.
          </p>

          <h3 data-id="element-441">4. Política de Reembolso</h3>
          <p data-id="element-442">
            Ofrecemos una <strong data-id="element-443">garantía de satisfacción de 7 días</strong>.
            Si por alguna razón no estás satisfecho con el producto, puedes
            solicitar el reembolso completo dentro de los 7 días posteriores a
            la compra directamente a través de la plataforma de Hotmart o
            contactándonos a nuestro correo de soporte.
          </p>

          <h3 data-id="element-444">5. Propiedad Intelectual</h3>
          <p data-id="element-445">
            Todo el contenido, incluyendo textos, gráficos, logos, imágenes y el
            material del ebook, está protegido por leyes de derechos de autor y
            propiedad intelectual. "Di Esto, No Aquello™" es una marca
            comercial de Amor Con Principios. El uso no autorizado de cualquier
            material está estrictamente prohibido.
          </p>

          <h3 data-id="element-446">6. Limitación de Responsabilidad</h3>
          <p data-id="element-447">
            Nuestros productos son educativos e informativos. No garantizamos
            resultados específicos en tus relaciones personales, ya que estos
            dependen de múltiples factores individuales. No somos responsables
            de ninguna decisión tomada basada en la información proporcionada en
            nuestros productos.
          </p>

          <h3 data-id="element-448">7. Modificaciones</h3>
          <p data-id="element-449">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación en el sitio web.
          </p>

          <h3 data-id="element-450">8. Ley Aplicable</h3>
          <p data-id="element-451">
            Estos términos se rigen e interpretan de acuerdo con las leyes de
            los Estados Unidos de América.
          </p>

          <h3 data-id="element-452">9. Contacto</h3>
          <p data-id="element-453">
            Si tienes alguna pregunta sobre estos términos, por favor
            contáctanos en:{' '}
            <a href="mailto:amorconprincipios.info@gmail.com" data-id="element-454">
              amorconprincipios.info@gmail.com
            </a>
            .
          </p>
        </div>
      </main>

      <Footer data-id="element-455" />
    </div>;
}